<template>
  <el-card>
    <el-form :model="formData" ref="form">
      <el-form-item :label="`${$t('序号')}：`">
        <span>{{formData.num || ""}}</span>
      </el-form-item>
      <el-form-item :label="`${$t('姓名')}：`">
        <span>{{formData.username || ""}}</span>
      </el-form-item>
      <el-form-item :label="`${$t('手机号')}：`">
        <span>{{formData.phone || ""}}</span>
      </el-form-item>
      <el-form-item :label="`${$t('身份证号')}：`">
        <span>{{formData.idNum || ""}}</span>
      </el-form-item>
      <el-form-item :label="`${$t('证件有限期限')}：`">
        <span>{{formData.credTime || ""}}</span>
      </el-form-item>
      <el-form-item>
        <div class="phone-row">
          <div class="item">
            <preview-img width="280px" height="160px" :img-url="formData.idZhengPhoto" />
            <span>{{ $t('身份证正面（国徽面）') }}</span>
          </div>
          <div class="item">
            <preview-img width="280px" height="160px" :img-url="formData.idFanPhoto" />
            <span>{{ $t('身份证反面') }}</span>
          </div>
        </div>
      </el-form-item>
      <el-form-item :label="`${$t('情况说明')}：`">
        <span>{{formData.content || ""}}</span>
      </el-form-item>
      <el-form-item :label="`${$t('审核意见')}：`">
        <el-radio-group v-model="formData.status">
          <el-radio label="pass">{{ $t('通过') }}</el-radio>
          <el-radio label="noPass">{{ $t('不通过') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item :label="`${$t('审核备注')}：`">
        <el-input type="textarea" v-model="formData.auditRemark" :rows="5" :placeholder="$t('请输入')" />
      </el-form-item>
      <el-form-item >
        <el-button type="primary" @click="handleSaveSubmit">{{ $t('确定') }}</el-button>
        <el-button @click="resetForm">{{ $t('重置') }}</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import {request} from "@/config/request";
import PreviewImg from "@/components/preview-img/PreviewImg.vue";

export default {
  name: "AuthAudit",
  components: {PreviewImg},
  data() {
    return {
      formData: {},
      rules: {
        status: "pass"
      }
    }
  },
  methods: {
    // 审核保存
    handleSaveSubmit() {
     this.$refs.form.validate(async (valid) => {
       if(!valid) return;
       try {
         const params = {...this.formData};
         delete params.createTime;
         delete params.updateTime;
         await request(this.$api.userAuth.updateStatus, params);
         this.$message.success(this.$t('操作成功'));
         this.$router.back();
       } catch (e) {
         console.log(e);
       }
     })
    },

    resetForm() {
      this.$refs.form.resetFields();
      this.formData.status = "pass";
    },

    async loadDetail() {
      try {
        const res = await request(this.$api.userAuth.detail, this.$route.query);
        this.formData = res.userAuth;
        this.formData.status = "pass";
      } catch (e) {
        console.log(e);
      }
    },
  },
  created() {
    this.loadDetail();
  }
}
</script>

<style scoped>
.el-form {
  width: 600px;
}

.phone-row {
  display: flex;
  align-items: center;
  column-gap: 16px;
}

.item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  row-gap: 12px;
}

</style>
